<template>
</template>

<script>
export default {
    data: function () {
        return {
            authNavHtml: '',
        }
    },
    props: [
        'authNavUrl',
    ],
    computed: {

    },
    created() {

    },
    mounted() {
        this.getAuthNav();
    },
    watch: {

    },
    methods: {
        getAuthNav() {
            axios
                .get(this.authNavUrl)
                .then(response => {
                    this.authNavHtml = response.data;
                })
                .catch(error => {
                    this.error = true;
                })
        },
    }
}
</script>
